// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ReportTemplateResults,
  ReportTemplateResultsFromJSON,
  ReportTemplateResultsToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface GetReportTemplateResultsRequest {
  id: number;
  dateFrom?: string;
  dateTo?: string;
}

/**
 * no description
 */
export class ReportTemplatesApi extends runtime.BaseAPI {
  /**
   * Runs a report that was already built in TestCollab and returns its aggregated rows. The report is identified by its id and its definition is resolved on the server, so nothing about how the report is built has to be sent with the request - which is what makes this endpoint suitable for a scheduled extract into a BI tool or a monitoring check.  Each row carries one key per dimension (the grouped value) and one key per metric (the computed number); `dimensions` and `metrics` describe those keys in order, so a client can map the rows to columns without knowing the report.  A report shared with the project (\"Public\") can be run by any member of the project; a \"Private\" report only by the person who created it.
   * Get results of a saved report
   */
  async getReportTemplateResultsRaw(
    requestParameters: GetReportTemplateResultsRequest
  ): Promise<runtime.ApiResponse<ReportTemplateResults>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getReportTemplateResults."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.dateFrom !== undefined) {
      queryParameters["date_from"] = requestParameters.dateFrom;
    }

    if (requestParameters.dateTo !== undefined) {
      queryParameters["date_to"] = requestParameters.dateTo;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/reporttemplates/{id}/results`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReportTemplateResultsFromJSON(jsonValue)
    );
  }

  /**
   * Runs a report that was already built in TestCollab and returns its aggregated rows. The report is identified by its id and its definition is resolved on the server, so nothing about how the report is built has to be sent with the request - which is what makes this endpoint suitable for a scheduled extract into a BI tool or a monitoring check.  Each row carries one key per dimension (the grouped value) and one key per metric (the computed number); `dimensions` and `metrics` describe those keys in order, so a client can map the rows to columns without knowing the report.  A report shared with the project (\"Public\") can be run by any member of the project; a \"Private\" report only by the person who created it.
   * Get results of a saved report
   */
  async getReportTemplateResults(
    requestParameters: GetReportTemplateResultsRequest
  ): Promise<ReportTemplateResults> {
    const response = await this.getReportTemplateResultsRaw(requestParameters);
    return await response.value();
  }
}
